export enum FuelType {
    SP95 = "SP95",
    SP98 = "SP98",
    DIESEL = "DIESEL",
    DIESEL_PREMIUM = "DIESEL_PREMIUM",
    GPL = "GPL",
    ADBLUE = "ADBLUE",
    CNG = "CNG",
    E85 = "E85",
    HVO100 = "HVO100",
    H2 = "H2"
}
export const FuelTypeValues = Object.values(FuelType)

// Normalize a raw fuel string from URL params: uppercase + fallback to SP95 if invalid.
export function normalizeFuelType(raw: string | undefined | null): FuelType {
    const upper = (raw ?? "").toUpperCase();
    return (FuelTypeValues as string[]).includes(upper) ? (upper as FuelType) : FuelType.SP95;
}
